import { request } from './request';

export interface UserRow {
  user_id: string;
  email: string;
  first_name: string;
  last_name: string;
  user_type_id: number;
  user_type: 'filmmaker' | 'client' | 'both';
  setup: boolean | null;
}

export const usersApi = {
  async getAll(): Promise<UserRow[]> {
    // Fetch with a high limit to get all users (avoiding default 1000 limit)
    return request<UserRow[]>('/user-api?limit=10000');
  },

  async getById(userId: string): Promise<any> {
    return request<any>(`/user-api/${userId}`);
  },

  async update(userId: string, data: any): Promise<any> {
    return request<any>(`/user-api/${userId}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  },

  async delete(userId: string): Promise<any> {
    return request<any>(`/user-api/${userId}`, {
      method: 'DELETE'
    });
  },

  async updateAuthMetadata(userId: string, metadata: any): Promise<any> {
    return request<any>(`/user-api/${userId}/auth-metadata`, {
      method: 'PATCH',
      body: JSON.stringify(metadata)
    });
  },
};